const posidonieData = [
    {
        lang: 'fr',
        titre: 'Posidonie',
        intro: 'Cet herbier de posidonie semble abîmé... Observons celui-ci, plusieurs espèces marines s’y cachent.',
        consigne: `<class="bold">Clique</class> sur les animaux que tu retrouves, chacun te donne <class="bold">une lettre</class>.\n<class="bold">Assemble-les</class> pour découvrir ce qui menace les posidonies !`,
        consigne2: 'Utilise les flèches pour te déplacer\ndans le décor.',
        recherche: `Où se trouve\n`,
        buttonLabel1: 'Suivant',
        buttonLabel2: 'Chercher',
        noms: [
            "l'oursin violet",
            'la tortue\ncaouanne',
            'le poulpe',
            "l'hippocampe",
            'la grande nacre',
        ],
        bonneReponseImage: 'bonne-rep-activite-1',
        mauvaiseReponseImage: 'mauvaise-rep-activite-1',
        bouteilleVideImage: 'bouteille-vide-activite-1',
        bouteilleFinaleImage: 'bouteille-finale',
        lettres: ['A', 'N', 'C', 'R', 'E'],
        xOffset: 0,
        XOffset2: 0,
        yOffset: 20,
        yOffset2: 10,
        positionsLettersCenter: [-120, -120 + 27, -120 + 54, -120 + 81, -120 + 108],
        endTitre: 'Bravo !',
        endTexte: `Tu as retrouvé les lettres du mot :`,
        endTexte2: `Jetée sans précaution, l’ancre des bateaux arrache les herbiers de posidonie et représente une grave menace pour cet habitat fragile.`,
    },
    {
        lang: 'en',
        titre: 'Posidonia',
        intro: 'This seagrass bed seems damaged... Let’s observe it, several marine species are hiding there.',
        consigne: `<class="bold">Click</class> on the animals you find, each one gives you  <class="bold">a letter</class>.\n<class="bold">Put them</class> together to discover what threatens posidonia!`,
        consigne2: 'Use the arrows to move\nthrough the scene.',
        recherche: `Where is the\n`,
        buttonLabel1: 'Next',
        buttonLabel2: 'Search',
        noms: ['purple sea\nurchin', 'loggerhead\nturtle', 'octopus', 'seahorse', 'pen shell'],
        bonneReponseImage: 'bonne-rep-activite-1-en',
        mauvaiseReponseImage: 'mauvaise-rep-activite-1-en',
        bouteilleVideImage: 'bouteille-vide-activite-1-en',
        bouteilleFinaleImage: 'bouteille-finale-en',
        lettres: ['N', 'C', 'H', 'O', 'R'],
        positionsLettersCenter: [-105, -105 + 27, -105 + 54, -105 + 81, -105 + 108],
        xOffset: 12,
        XOffset2: 20,
        yOffset: 25,
        yOffset2: 0,
        endTitre: 'Well done !',
        endTexte: `You found the letters of the word:`,
        endTexte2: `When dropped carelessly, boat anchors tear up the posidonia beds and pose a serious threat to this fragile habitat.`,
    },
    {
        lang: 'it',
        noms: ['purple sea\nurchin', 'loggerhead\nturtle', 'octopus', 'seahorse', 'pen shell'],
        lettres: ['N', 'C', 'O', 'R', 'A'],
        bouteilleVideImage: 'bouteille-vide-activite-1-en',
        positionsLettersCenter: [-105, -105 + 27, -105 + 54, -105 + 81, -105 + 108],
        xOffset: 12,
        XOffset2: 20,
        yOffset: 25,
        yOffset2: 0,
    },
    {
        lang: 'de',
        noms: ['lila Seeigel', 'unechte Karettschildkröte', 'Oktopus', 'Seepferdchen', 'Pen Shell'],
        lettres: ['A', 'N', 'K', 'E', 'R'],
        bouteilleVideImage: 'bouteille-vide-activite-1',
        xOffset: 0,
        XOffset2: 0,
        yOffset: 20,
        yOffset2: 10,
        positionsLettersCenter: [-120, -120 + 27, -120 + 54, -120 + 81, -120 + 108],
    },
    {
        lang: 'pol',
        noms: ['lila Seeigel', 'unechte Karettschildkröte', 'Oktopus', 'Seepferdchen', 'Pen Shell'],
        lettres: ['T', 'W', 'I', 'C', 'A'],
        bouteilleVideImage: 'bouteille-vide-activite-1-pol',
        positionsLettersCenter: [-95, -95 + 27, -95 + 54, -95 + 81, -95 + 108],
        xOffset: 25,
        XOffset2: 30,
        yOffset: 25,
        yOffset2: 0,
    },
    {
        lang: 'es',
        titre: 'Posidonie',
        intro: 'Cet herbier de posidonie semble abîmé... Observons celui-ci, plusieurs espèces marines s’y cachent.',
        consigne: `<class="bold">Clique</class> sur les animaux que tu retrouves, chacun te donne <class="bold">une lettre</class>.\n<class="bold">Assemble-les</class> pour découvrir ce qui menace les posidonies !`,
        consigne2: 'Utilise les flèches pour te déplacer\ndans le décor.',
        recherche: `Où se trouve\n`,
        buttonLabel1: 'Suivant',
        buttonLabel2: 'Chercher',
        noms: [
            "l'oursin violet",
            'la tortue\ncaouanne',
            'le poulpe',
            "l'hippocampe",
            'la grande nacre',
        ],
        bonneReponseImage: 'bonne-rep-activite-1',
        mauvaiseReponseImage: 'mauvaise-rep-activite-1',
        bouteilleVideImage: 'bouteille-vide-activite-1',
        bouteilleFinaleImage: 'bouteille-finale',
        lettres: ['A', 'N', 'C', 'R', 'E'],
        xOffset: 0,
        XOffset2: 0,
        yOffset: 20,
        yOffset2: 10,
        positionsLettersCenter: [-120, -120 + 27, -120 + 54, -120 + 81, -120 + 108],
        endTitre: 'Bravo !',
        endTexte: `Tu as retrouvé les lettres du mot :`,
        endTexte2: `Jetée sans précaution, l’ancre des bateaux arrache les herbiers de posidonie et représente une grave menace pour cet habitat fragile.`,
    },
];

export default posidonieData;
